import { useTranslation } from 'react-i18next';
import { useFeatureToggleContext } from 'FeatureConfig.context';
import { useProgressReturnShipment } from '../../hooks';
import type { ShipmentProgress } from '../../models';
import { Item, ItemProps } from '../Item';
import { useProgressPreprintedReturnShipment } from '../../hooks/useProgressPreprintedReturnShipment';

type ItemReturnProps = Omit<ItemProps, keyof ShipmentProgress>;

const ItemReturn: React.FC<ItemReturnProps> = ({ ...props }) => {
  const featureToggles = useFeatureToggleContext();
  const preprintedProgress = useProgressPreprintedReturnShipment(
    props.baseShipment,
  );
  const regularProgress = useProgressReturnShipment(props.baseShipment);

  const isPreprintedEnabled =
    featureToggles?.returnManagement?.enablePreprintedReturnLabel;
  const progressProps = isPreprintedEnabled
    ? preprintedProgress
    : regularProgress;

  const { t } = useTranslation();

  return <Item {...props} label={t('RETURN')} {...progressProps} />;
};

export default ItemReturn;
